const BaseComponent = require('common/home/view');

class Home extends BaseComponent {}

module.exports = Home;
